<template>
  <div>
    <div class="info" v-if="$store.state.user.isLogin">
      <!-- 已登录：{{account.username}} -->
      <el-card style="margin-bottom: 20px;" v-if="$store.getters.isAudit" v-loading="loading">
        <div slot="header" class="clearfix">
          <span>待办</span>
        </div>
        <el-badge v-if="$store.getters.isAudit" :value="auditCount" style="margin-right: 30px;">
          <el-button size="small" type="primary" @click="$router.push({ path: '/admin/audit' })">
            待审核的信息</el-button>
        </el-badge>
        <!-- <el-badge v-if="isAdminAccountBox" :value="adminAccountBoxData.toAuditCount" style="margin-right: 30px;">
          <el-button size="small" type="primary"
            @click="$router.push({ path: '/admin/account/list', query: { state: 0 } })">
            待审核的账号</el-button>
        </el-badge>
        <el-badge v-if="isAdminAccountBox" :value="adminAccountBoxData.inReviewCount" style="margin-right: 30px;">
          <el-button size="small" type="success"
            @click="$router.push({ path: '/admin/account/list', query: { state: 2 } })">
            审核中的账号</el-button>
        </el-badge> -->
        <!-- <el-badge v-if="isMembersContributeBox" :value="membersContributeData.toBeReviewed" style="margin-right: 30px;">
          <el-button size="small" type="primary"
            @click="$router.push({ path: '/admin/information/membersContribute', query: { state: 0 } })">
            待审核的会员投稿</el-button>
        </el-badge>
        <el-badge v-if="isMembersContributeBox" :value="membersContributeData.underReview" style="margin-right: 30px;">
          <el-button size="small" type="success"
            @click="$router.push({ path: '/admin/information/membersContribute', query: { state: 3 } })">
            审核中的会员投稿</el-button>
        </el-badge> -->
        <!-- <el-badge :value="adminAccountBoxData.inReviewCount" style="margin-right: 30px;">
          <el-button size="small" type="primary" @click="$router.push({path:'/admin/account/list',query:{state:2} })">会员投稿待审核</el-button>
        </el-badge> -->
      </el-card>

      <el-card class="user-info-card">
        <!-- <div slot="header" class="clearfix"> -->
        <!-- <span>账号详细信息</span>
          <el-button v-if="account.accountType == 0" @click="dialogIndividualEditShow = true"
            style="float: right; padding: 3px 0" type="text">编辑信息</el-button>
          <el-button v-if="account.accountType == 1" @click="dialogEnterpriseEditShow = true"
            style="float: right; padding: 3px 0" type="text">编辑信息</el-button> -->
        <!-- </div> -->

        <el-tabs v-model="activeName">
          <el-tab-pane label="个人信息" name="info">
            <AccountDetails :account="account" :details="details" />
            <el-button v-if="account.accountType == 0" style="margin-top: 10px;margin-bottom: 10px;"
              @click="dialogIndividualEditShow = true" type="primary" size="small">
              编辑信息</el-button>
            <el-button v-if="account.accountType == 1" style="margin-top: 10px;margin-bottom: 10px;"
              @click="dialogEnterpriseEditShow = true" type="primary" size="small">
              编辑信息</el-button>
          </el-tab-pane>
          <!-- <el-tab-pane label="社交账号关联" name="second">
            <el-alert title="无需关联社交账号" type="info" :closable="false">
            </el-alert>
          </el-tab-pane> -->
          <el-tab-pane label="密码修改" name="pass">
            <el-form ref="formPass" :model="formPass" label-width="130px" v-loading="loading" :rules="rulesPass">
              <el-form-item label="账号" prop="username">
                <el-input :value="account.username" disabled></el-input>
              </el-form-item>
              <el-form-item label="旧密码" prop="oldPassword">
                <el-input v-model="formPass.oldPassword" type="password"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="formPass.newPassword" type="password"></el-input>
              </el-form-item>
              <el-form-item label="" prop="">
                <el-button @click="$emit('update:visible', false)">取 消</el-button>
                <el-button type="primary" @click="submitPass" :loading="loadingPass">提 交</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>



        <!-- <el-button @click="dialogPasswordEditShow = true" type="warning" size="small">修改密码</el-button> -->

      </el-card>
    </div>
    <div v-else>未登录</div>

    <AccountEdit :visible.sync="dialogIndividualEditShow" :data="{ ...account, ...details }" :is-edit="true"
      @submit="init" append-to-body />
    <AccountEdit :visible.sync="dialogEnterpriseEditShow" :data="{ ...account, ...details }" :is-edit="true"
      @submit="init" append-to-body />
    <AccountPasswordEdit :visible.sync="dialogPasswordEditShow" :data="account" :is-edit="true" @submit="init"
      append-to-body />
  </div>
</template>

<script>
import api from "@/api/information.js";
import { getCurUser } from "@/api/auth.js";
import AccountEdit from "../account/AccountEdit.vue";
import { getStateNum, toResetPassword } from "@/api/account.js";
import EnterpriseMemberEdit from "../account/EnterpriseMemberEdit.vue";
import IndividualMemberEdit from "../account/IndividualMemberEdit.vue";
import AccountDetails from "../account/AccountDetails.vue";
import AccountPasswordEdit from "../account/AccountPasswordEdit.vue";
import { pageQueryAll } from "@/api/audit.js";
const { membersContribute } = api
export default {
  components: {
    EnterpriseMemberEdit,
    IndividualMemberEdit,
    AccountEdit,
    AccountDetails,
    AccountPasswordEdit,
  },
  data() {
    var validateEng = (rule, value, callback) => {
      let zmReg = /[A-Za-z]/; // 大小写字母
      let numReg = /[0-9]/; // 数字
      let zfReg = /[^A-Za-z0-9\s]/; // 特殊字符不包含空格
      let complex = 0;
      if (zmReg.test(value)) {
        ++complex;
      }
      if (numReg.test(value)) {
        ++complex;
      }
      if (zfReg.test(value)) {
        ++complex;
      }
      if (complex < 2) {
        // 密码需包含字母，符号或者数字中至少两项
        callback(new Error("密码需包含字母，符号或者数字中至少两项"));
      } else {
        callback();
      }
    };
    return {
      auditCount: 0,
      activeName: "info",
      isAdminAccountBox: false,
      loading: false,
      adminAccountBoxData: {
        inReviewCount: 0,
        toAuditCount: 0,
      },
      isMembersContributeBox: false,
      membersContributeData: {
        toBeReviewed: 0,
        underReview: 0,
      },


      // activeName: "1",
      // 是否显示下拉的box
      // account:{},
      // details:{}
      dialogEnterpriseEditShow: false,
      dialogIndividualEditShow: false,
      dialogPasswordEditShow: false,


      formPass: {
        username: "",
        oldPassword: "",
        newPassword: "",
      },
      loadingPass: false,
      rulesPass: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 6, message: "密码需要在长度在6位以上", trigger: "blur", },
          { validator: validateEng, trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码需要在长度在6位以上", trigger: "blur", },
          { validator: validateEng, trigger: "blur" },],
      },
    };
  },
  mounted() {
    this.$store.dispatch("isMenu", "account").then((res) => {
      this.isAdminAccountBox = res;
      if (res) {
        this.loading = true;
        getStateNum()
          .then((res) => {
            this.adminAccountBoxData = res.data
          })
          .finally(() => {
            this.loading = false;
          });
      }
    });
    pageQueryAll().then((res) => {
      const { data } = res;
      this.auditCount = data.count
    })

    // this.$store.dispatch("isMenu", "membersContribute").then((res) => {
    //   this.isMembersContributeBox = res;
    //   if (res) {
    //     this.loading = true;
    //     membersContribute.getAuditNum()
    //       .then((res) => {
    //         console.log(res);
    //         this.membersContributeData = res.data
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    //   }
    // });
  },
  computed: {
    account() {
      return {
        ...(this.$store.state.user.info.acount || {}),
        roles: this.$store.state.user.info.roles || [],
      };
    },
    details() {
      return this.$store.state.user.info.details || {};
    },
  },
  methods: {
    init() {
      this.$store.dispatch("init");
    },
    getCurUser() {
      getCurUser().then((res) => {
        // console.log(res);
        this.account = res.data.acount;
        this.details = res.data.details;
      });
    },

    submitPass() {
      this.$refs["formPass"].validate((valid, key) => {
        if (valid) {
          this.loadingPass = true;
          toResetPassword({
            id: this.account.id,
            oldPassword: this.formPass.oldPassword,
            newPassword: this.formPass.newPassword
          })
            .then(() => {
              this.$message.success("修改成功, 请重新登录");
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              })
              this.formPass.oldPassword = ''
              this.formPass.newPassword = ''
            })
            .finally(() => {
              this.loadingPass = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
 
<style lang="less" scoped>
.list {
  padding-left: 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  // grid-template-rows: 30px 30px 30px;
  >div {
    padding: 13px 0;
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 17px;
    color: #000;
    box-sizing: border-box;
    max-width: 90%;

    >div:nth-child(1) {
      width: 150px;
      min-width: 150px;
    }

    >div:nth-child(2) {
      flex: 1;
    }

    >a {
      overflow: hidden;
      word-wrap: break-word;
    }
  }
}

.user-info-card {
  /deep/ .el-card__body {
    padding: 8px 18px !important;
  }
}
</style>